import { LogService } from '../../../../shared/services/log.service';
import { Validator } from '../../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../../ctrl.name.extractor';

export class CTRL_21 implements Validator {

    public static id = 'CTRL_21';
    private message = 'error.ctr_21';


    public LOG: LogService = new LogService(CTRL_21);

    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_21.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const adrPaysNameWithStepId = map.get(ctrl.value.rgCtrls.adrPays);
                const codeNUTSNameWithStepId = map.get(ctrl.value.rgCtrls.codeNUTS);
                const adrPaysCtrl = form.controls[adrPaysNameWithStepId];
                const codeNUTSCtrl = form.controls[codeNUTSNameWithStepId];

                if (adrPaysCtrl === undefined || codeNUTSCtrl === undefined && (adrPaysCtrl.value === codeNUTSCtrl.value.substr(0, 2)) || (codeNUTSCtrl.value.substr(0, 2) === 'FR' && !adrPaysCtrl.value)) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}
